import { SpotSearchIndexResult } from "../generatedApi/adminSearchEngineApi";

export type BulkOperationResult = {
  spotId: string;
  name: string;
  status: "success" | "skip" | "error" | "unchanged" | "not_found";
  message?: string;
  oldPlaceId?: string;
  newPlaceId?: string;
};

export type SpotWithGooglePlaceId = SpotSearchIndexResult & {
  google_place_id: string;
};

/**
 * SpotSearchIndexResultがgoogle_place_idを持つかチェックする型ガード
 */
export function hasGooglePlaceId(spot: SpotSearchIndexResult): spot is SpotWithGooglePlaceId {
  return "google_place_id" in spot && typeof (spot as any).google_place_id === "string";
}
